import { Component, Input } from '@angular/core';
import { PictureDisplay, PictureImage } from '@freelancer/ui/picture';

@Component({
  selector: 'app-source-template-logo',
  template: `
    <fl-picture
      class="SourceTemplateLogo"
      [alt]="image.alt"
      [src]="image.src"
      [boundedWidth]="true"
      [display]="PictureDisplay.BLOCK"
    ></fl-picture>
  `,
  styleUrls: ['./source-template-logo.component.scss'],
})
export class SourceTemplateLogoComponent {
  PictureDisplay = PictureDisplay;
  @Input() image: PictureImage;
}
